import { BrainIcon } from "../assets/icons";

export default function Logo() {
  return (
    <div className="logo">
      <BrainIcon />
      <div className="logoText">Brain</div>
    </div>
  );
}
